import {useQuery} from 'react-query';

import getAdCatalog from '.';

const useGetAdCatalog = (payload: IAdCatalogProps) => {
  const {data, isLoading} = useQuery(['get-add-catalog', payload], () =>
    getAdCatalog(payload),
  );
  return {
    addCatalogData: data,
    catalogDataIsLoading: isLoading,
  };
};

export default useGetAdCatalog;
